// removed by extract-text-webpack-plugin
module.exports = {"toggleNew":"field-mapping__toggleNew-26Br_","delete":"field-mapping__delete-Y-9d2","control":"field-mapping__control-3r3IY","tooltipWrapper":"field-mapping__tooltipWrapper-1d6ol","tooltip":"field-mapping__tooltip-pG8XZ blocks__tooltip-20lA1 blocks__isShown--23z3"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/bitrix-export-leads/field-mapping/field-mapping.css
// module id = 752
// module chunks = 0